"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";
import type { PlatformId } from "@/types/platforms";

interface PlatformLogoProps {
  platform: PlatformId;
  size?: number;
  className?: string;
}

export function PlatformLogo({
  platform,
  size = 24,
  className,
}: PlatformLogoProps) {
  return (
    <Image
      src={`/api/images/platform-logo/${platform}/`}
      alt={platform}
      width={size}
      height={size}
      unoptimized
      className={cn("shrink-0 object-contain", className)}
    />
  );
}
